(function () {
  'use strict';

  angular
    .module('message')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('alertManager', {
    	sticky: true,
        url: '/alert-manager',
        views: {
            'alertManagerView': {
            	templateUrl: 'message/views/alert-manager.tpl.html',
                controller: 'AlertManagerCtrl',
                controllerAs: 'alertManager'
            }
        }
        
      });
  }
}());
